export default __webpack_public_path__ + "static/media/goodFridayTopLogo.fc5e999d.png";